import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export function AdminWelcomePopup() {
  const { user, refreshUser } = useAuth();
  const nav = useNavigate();
  const show = user?.role === "admin" && !user.is_owner && user.appointed_at && !user.admin_welcome_seen_at;
  const [open, setOpen] = useState(true);
  if (!show) return null;
  const close = async (go) => {
    setOpen(false);
    await api.post("/admin/welcome/seen").catch(() => {});
    refreshUser?.();
    if (go) nav("/admin");
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close(false)}>
      <DialogContent className="max-w-sm rounded-3xl text-center" data-testid="admin-welcome-popup">
        <span className="mx-auto w-16 h-16 rounded-full bg-gradient-to-br from-amber-300 to-amber-500 text-white grid place-items-center shadow-lg shadow-amber-200"><Crown className="w-8 h-8" /></span>
        <DialogTitle className="text-2xl font-extrabold">Du wurdest zum Admin ernannt! 🎉</DialogTitle>
        <DialogDescription className="text-[15px] leading-relaxed text-slate-600">
          Herzlichen Glückwunsch und danke für deine Hilfe! Ab sofort hast du ein eigenes Admin-Menü. Dort erklären wir dir zuerst in einer kurzen Einführung Schritt für Schritt alles Wichtige.
        </DialogDescription>
        <button onClick={() => close(true)} data-testid="admin-welcome-go" className="h-12 rounded-full bg-gradient-to-r from-rose-500 to-pink-500 text-white font-extrabold inline-flex items-center justify-center gap-2">Zu meinem Admin-Menü <ArrowRight className="w-4 h-4" /></button>
        <button onClick={() => close(false)} data-testid="admin-welcome-later" className="text-sm font-semibold text-slate-400">Später</button>
      </DialogContent>
    </Dialog>
  );
}
